import React from 'react';

const SNIPPETS = [
  { label: '∫', latex: '$\\int_{a}^{b} f(x)\\,dx$', title: 'İntegral' },
  { label: '∬', latex: '$\\iint_{R} f(x,y)\\,dA$', title: 'Çift katlı integral' },
  { label: '∭', latex: '$\\iiint_{S} f(x,y,z)\\,dV$', title: 'Üçlü katlı integral' },
  { label: 'lim', latex: '$\\lim_{x \\to a} f(x)$', title: 'Limit' },
  { label: 'd/dx', latex: '$\\frac{d}{dx}$', title: 'Türev' },
  { label: '∂/∂x', latex: '$\\frac{\\partial f}{\\partial x}$', title: 'Kısmi türev' },
  { label: 'a/b', latex: '$\\frac{a}{b}$', title: 'Kesir' },
  { label: '√', latex: '$\\sqrt{x}$', title: 'Karekök' },
  { label: 'ⁿ√', latex: '$\\sqrt[n]{x}$', title: 'n. dereceden kök' },
  { label: 'xⁿ', latex: '$x^{n}$', title: 'Üs' },
  { label: 'xₙ', latex: '$x_{n}$', title: 'Alt indis' },
  { label: 'Σ', latex: '$\\sum_{i=1}^{n} a_i$', title: 'Toplam' },
  { label: 'Π', latex: '$\\prod_{i=1}^{n} a_i$', title: 'Çarpım' },
  { label: '∞', latex: '$\\infty$', title: 'Sonsuz' },
  { label: 'π', latex: '$\\pi$', title: 'Pi' },
  { label: 'θ', latex: '$\\theta$', title: 'Theta' },
  { label: 'α', latex: '$\\alpha$', title: 'Alfa' },
  { label: 'β', latex: '$\\beta$', title: 'Beta' },
  { label: '≤', latex: '$\\leq$', title: 'Küçük eşit' },
  { label: '≥', latex: '$\\geq$', title: 'Büyük eşit' },
  { label: '≠', latex: '$\\neq$', title: 'Eşit değil' },
  { label: '→', latex: '$\\to$', title: 'Ok' },
  { label: '(matris)', latex: '$\\begin{pmatrix} a & b \\\\ c & d \\end{pmatrix}$', title: 'Matris (parantezli)' },
  { label: '|matris|', latex: '$\\begin{vmatrix} a & b \\\\ c & d \\end{vmatrix}$', title: 'Determinant' },
  { label: '{cases}', latex: '$\\begin{cases} x+y=1 \\\\ x-y=2 \\end{cases}$', title: 'Sistem' },
  { label: 'vec', latex: '$\\vec{v}$', title: 'Vektör' },
];

const btnStyle = {
  padding: '4px 8px',
  fontSize: '12px',
  background: '#fff',
  border: '1px solid #cbd5e1',
  borderRadius: '5px',
  cursor: 'pointer',
  color: '#0f172a',
  fontWeight: 500,
  whiteSpace: 'nowrap',
};

const MathToolbar = ({ targetRef, value, onChange }) => {
  const insert = (snippet) => {
    const el = targetRef && targetRef.current;
    if (!el) {
      onChange((value || '') + ' ' + snippet);
      return;
    }
    const start = el.selectionStart ?? (value || '').length;
    const end = el.selectionEnd ?? (value || '').length;
    const before = (value || '').substring(0, start);
    const after = (value || '').substring(end);
    const newValue = before + snippet + after;
    onChange(newValue);
    setTimeout(() => {
      try {
        el.focus();
        const pos = start + snippet.length;
        el.setSelectionRange(pos, pos);
      } catch (e) { /* noop */ }
    }, 0);
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', padding: '6px', background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '6px', marginBottom: '4px' }}>
      {SNIPPETS.map((s, i) => (
        <button
          key={i}
          type="button"
          style={btnStyle}
          title={s.title + ' — ' + s.latex}
          onMouseDown={(e) => { e.preventDefault(); insert(s.latex); }}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
};

export default MathToolbar;
